/**
* lr colorblock JS
* -----------------------------------------------------------------------------
*
* All the JS for the lr colorblock component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'lr-colorblock',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( function() {
        if ( window.innerWidth >= 1024 ) {
          $( '.lr-colorblock' ).each( function() {
            const $colorBlockBG = $( this ).find( '.lr-colorblock__background' ).outerHeight();
            const imgOverlap = 128;
            const $image = $( this ).find( '.fit-image img' );
            $image.css( {'height': `${ $colorBlockBG + imgOverlap + 'px'}`, 'transform': 'translateY(-64px)'} );
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'lr-colorblock', COMPONENT );
} )( app );
